import { Modal, Button } from 'antd'
import { history } from 'umi'
import styles from './index.less'

const CheckHasBindShopModal = ({ visible, onCancel }) => {
    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            title="温馨提示"
            width={600}
            footer={<Button onClick={onCancel}>我知道了</Button>}
        >
            <div className={styles.content}>
                <img
                    className={styles.image}
                    src="https://assets.sursung.com/activity/2024_imgs/dis/front/3F6316D107C74CD0AC47504CFB611E0A1632381269413.png"
                />
                <div className={styles.title}>您当前未绑定线上平台店铺，请先绑定线上平台店铺</div>
                <Button
                    type="primary"
                    className={styles.bindBtn}
                    onClick={() => {
                        onCancel()
                        history.push(
                            window.MASTER_IS_SUPPLIER
                                ? '/storeManage/list?create=1'
                                : '/channel/my/storeManage?create=1',
                        )
                    }}
                >
                    立即去绑定
                </Button>
                <Button
                    className={styles.helpBtn}
                    type="link"
                    onClick={() =>
                        window.open('https://sc.scm121.com/help?docId=10277#《1分钟带你了解什么是【寻合作】》')
                    }
                >
                    什么是寻合作?
                </Button>
            </div>
        </Modal>
    )
}

export default CheckHasBindShopModal
